document.addEventListener('DOMContentLoaded', function() {
	const showLoginModalLinks = document.querySelectorAll('.js-show-login-modal');

	showLoginModalLinks.forEach(function(modalLink) {
		modalLink.addEventListener('click', function(e) {
			e.preventDefault();
			document.querySelector('.js-react-login-modal').click();
		});
	});
});
